const template = document.querySelector('body');

/********* Navigation *********/
const menusLvl2 = document.querySelectorAll('.mega-menu__submenu-lvl2');
menusLvl2.forEach((menuLvl2) => {
    // Init
    const menuLvl1 = menuLvl2.closest('details');
    const menuLvl2Item = menuLvl2.querySelector('li:first-child');
    loadMenu(menuLvl1, menuLvl2Item, '[data-ref]:first-child', ':first-child');
    menuLvl1.addEventListener('mouseleave', (e) => {
        loadMenu(menuLvl1, menuLvl2Item, '[data-ref]:first-child', ':first-child');
    });

    // Hover Lvl2
    if (window.matchMedia('(min-width: 1024px)').matches) {
        const menuLvl2Items = menuLvl1.querySelectorAll('.mega-menu__submenu-lvl2 li');
        menuLvl2Items.forEach((menuLvl2Item) => {
            menuLvl2Item.addEventListener('mouseover', (e) => {
                if (!menuLvl2Item.classList.contains('active')) {
                    const target = menuLvl2Item.getAttribute('data-ref');
                    loadMenu(menuLvl1, menuLvl2Item, '[data-ref="'+target+'"]', '#'+target);
                }
            });
        });
    }
});
function loadMenu(menuLvl1, menuLvl2, menuLvl3Selector, pushSelector) {
    // Lvl2
    const menuLvl2Active = menuLvl1.querySelector('.mega-menu__submenu-lvl2 li.active');
    if (menuLvl2Active) {
        menuLvl2Active.classList.remove('active');
    }
    menuLvl2.classList.add('active');

    // Lvl3
    const menuLvl3Active = menuLvl1.querySelector('.mega-menu__submenu-lvl3 .active');
    if (menuLvl3Active) {
        menuLvl3Active.classList.remove('active');
    }
    const menuLvl3 = menuLvl1.querySelector('.mega-menu__submenu-lvl3 '+menuLvl3Selector);
    if (menuLvl3) {
        menuLvl3.classList.add('active');
    }

    // Push
    const pushActive = menuLvl1.querySelector('.mega-menu__promotions .active');
    if (pushActive) {
        pushActive.classList.remove('active');
    }
    const push = menuLvl1.querySelector('.mega-menu__promotions .push-wrapper'+pushSelector);
    if (push) {
        push.classList.add('active');
    }
}

/********* Homepage *********/
if (template.classList.contains('index-template')) {
	const headerAnnoncement = document.querySelector('.shopify-section-group-header-group.announcement-bar-section');

		if (headerAnnoncement) {
			const moveAnnouncement = () => {
				const headerTransparent = document.querySelector('.shopify-section-group-header-group.header-transparent');
				if (!headerTransparent) return;

			// On cherche la première section "visuelle" réellement visible
			const selectors = [
				'.video-hero',
				'.section--slideshow',
				'.image-with-text-overlay'
			];

			const visibleSection = selectors
				.map(sel => Array.from(document.querySelectorAll(sel)))
				.flat()
				.find(el => window.getComputedStyle(el).display !== 'none');

			if (visibleSection) {
				const sectionContainer = visibleSection.closest('.shopify-section');
					if (sectionContainer) {
						sectionContainer.after(headerAnnoncement);
						headerAnnoncement.style.display = "block";
				}
			}
		};

		// Exécute après le chargement initial
		setTimeout(moveAnnouncement, 200);
		// Et à chaque redimensionnement (pour mobile/desktop)
		window.addEventListener('resize', moveAnnouncement);
	}
}

/********* Show/Hide *********/
const showHideElements = document.querySelectorAll('.show-hide');
showHideElements.forEach((showHideElement) => {
    const showHideContent = showHideElement.querySelector('.show-hide-content');
    const showHideBtn = showHideElement.querySelector('.show-hide-btn');

    if (showHideContent && showHideBtn) {
        showHideBtn.addEventListener('click', () => {
            showHideElement.classList.toggle('active');

            if (showHideElement.classList.contains('active')) {
                showHideContent.style.maxHeight = showHideContent.scrollHeight + 'px';
            } else {
                showHideContent.style.maxHeight = '';
            }
        });
    }
});

/********* Product card *********/
function sliderCardProduct (productSliders) {
    productSliders.forEach((slider) => {
        const sliderOptions = {
            modules: [window.FoxTheme.Swiper.Navigation, window.FoxTheme.Swiper.Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-btn-next'),
                prevEl: slider.querySelector('.swiper-btn-prev'),
            },
            loop: true,
        };

        const sliderInstance = new FoxTheme.Swiper.Swiper(slider, sliderOptions);
        sliderInstance.init();
    });
}
const productSliders = document.querySelectorAll('card-product-image-slider');
sliderCardProduct (productSliders);

setTimeout(()=> {
    const productSliders = document.querySelectorAll('product-slider card-product-image-slider');
    sliderCardProduct (productSliders);
}
,1000);

/********* Product *********/
if (template.classList.contains('product-template')) {
    function changeBadgeLocation() {
        const badgesContainer = document.querySelector('.product__block.product__block--badges');
        const badge = document.querySelector('.product-card__badge');
        const mediaWrapper = document.querySelector('.product__media-wrapper');
        const infoWrapper = document.querySelector('.product__info-wrapper');

        if (!badge || !badgesContainer || !mediaWrapper || !infoWrapper) return;

        if (window.matchMedia('(max-width: 767.98px)').matches) {
            mediaWrapper.appendChild(badge);
        } else {
            badgesContainer.appendChild(badge);
        }
    }

    changeBadgeLocation();
    window.addEventListener("resize", changeBadgeLocation);

    const loadMoreBtn = document.querySelector('.product__media-wrapper .btn[data-load-more]');
    if (loadMoreBtn) {
        const galleryWrapper = document.querySelector('.product__media-wrapper');
        loadMoreBtn.addEventListener('click', () => {
            galleryWrapper.classList.add('active');
        });
    }

    const showDeliveryInfo = document.querySelector('.product__block--\\@app');
    if (showDeliveryInfo) {
        const showDeliveryInfoModal = showDeliveryInfo.nextElementSibling;

        if (showDeliveryInfoModal && showDeliveryInfoModal.classList.contains('product__block--popup')) {
            showDeliveryInfoModal.style.display = 'none';
            showDeliveryInfo.addEventListener('click', () => {
                showDeliveryInfoModal.querySelector('button').click();
            });
        }
    }
}
